function focusNextElement(element: HTMLElement, excludeContainer: Nullable<HTMLElement> = null)
{
    focusElement(1, element, excludeContainer);
}

function focusPreviousElement(element: HTMLElement, excludeContainer: Nullable<HTMLElement> = null)
{
    focusElement(-1, element, excludeContainer);
}

function focusElement(pointer: number, element: HTMLElement, excludeContainer: Nullable<HTMLElement>)
{
    const focusableElements  = getKeyboardFocusableElements() as HTMLElement[];

    if(excludeContainer)
    {
        const containerFocusableElements = getKeyboardFocusableElements(excludeContainer) as HTMLElement[];

        // filter inline-date-picker elements
        focusableElements.splice(focusableElements.indexOf(containerFocusableElements[0]), containerFocusableElements.length);
    }

    const index = focusableElements.indexOf(element);

    if(focusableElements[index + pointer])
    {
        focusableElements[index + pointer].focus();
    }
    else if(focusableElements[0])
    {
        focusableElements[0].focus();
    }
}

function getKeyboardFocusableElements(element: Nullable<HTMLElement> = null)
{
    return [...(element || document).querySelectorAll(
        'a, button:not([disabled="disabled"]):not(.button-disabled), input:not([hidden="hidden"]), textarea, select:not(.kool-choiz-select), .kool-choiz, [tabindex]:not([tabindex="-1"]):not(.popup-focus-trap)'
    )].filter(el => !el.hasAttribute('disabled') || !el.hasAttribute('tabindex') || parseInt(el.getAttribute('tabindex') as string) >= 0) as HTMLElement[];
}

function queryFocusableElements(element: HTMLElement | Document = document): NodeListOf<HTMLElement>
{
    return element.querySelectorAll(
        'a, button:not([disabled="disabled"]):not(.button-disabled), input:not([hidden="hidden"]):not([type="hidden"]), textarea, select:not(.kool-choiz-select), .kool-choiz, [tabindex]:not([tabindex="-1"]):not(.popup-focus-trap)'
    );
}

export {
    focusNextElement,
    focusPreviousElement,
    getKeyboardFocusableElements,
    queryFocusableElements,
}